import React, { useContext, useEffect, useState } from 'react'
import { BsDownload, BsPencil } from 'react-icons/bs'
import { FaCaretDown, FaPrint } from 'react-icons/fa6'
import { FiRefreshCcw } from 'react-icons/fi'
import { IoSettingsOutline } from 'react-icons/io5'
import { Link } from 'react-router-dom'
import moment from "moment";
import { CommonDateRange, Heading } from 'components'
import StorageService from 'utils/StorageServices/StorageServices'
import { generalLedger, profitLossReportList } from '_services/reportService/reportService'
import { utils } from 'helper'
import { UserContext } from 'context'

const GeneralLedger = () => {

  const { generalLedgerDate, setGeneralLedgerDate } = useContext(UserContext);
  const [generalLedgerData, setGeneralLedgerData] = useState({});
  const [loading, setLoading] = useState(false);
  const currentDate = new Date();
  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

  const [selectedRange, setSelectedRange] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  });

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setGeneralLedgerDate(newRange)
  };

  useEffect(() => {
    getGeneralReportList()
  }, [selectedRange])

  const getGeneralReportList = async () => {
    setLoading(true)
    const payload = {
      company_id: StorageService.getCompanyId(),
      start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
      end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
    }
    try {
      const res = await generalLedger(payload);
      if (res?.responseCode == 200) {
        setGeneralLedgerData(res?.data)
        setLoading(false)
      } else {
        setLoading(false)
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const resetFunction = () => {
    const newStartDate = moment().startOf('month');
    const newEndDate = moment().endOf('month');

    setSelectedRange({
      startDate: newStartDate,
      endDate: newEndDate,
    });

    setGeneralLedgerDate({
      startDate: newStartDate,
      endDate: newEndDate,
    });
  };

  return (
    <>
      <div className='__znDe_mainBx'>
        <div>
          <div className='panel-heading'>
            <h2><span>{loading ? 'Loading...' : 'General Ledger List'}</span></h2>

            <div className='panel-ctrls report-control'>
              <div>
                <CommonDateRange
                  key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                  initialStartDate={selectedRange.startDate}
                  initialEndDate={selectedRange.endDate}
                  onApply={handleApply}
                />
              </div>

              {/* <div class="dropdown">
                <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  This Year
                  <FaCaretDown />
                </button>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item" href="#">Action</a></li>
                  <li><a class="dropdown-item" href="#">Another action</a></li>
                  <li><a class="dropdown-item" href="#">Something else here</a></li>
                </ul>
              </div> */}

              {/* <button className='__bxs_srBtn'>
                <IoSettingsOutline />
              </button> */}

              <button className='__bxs_srBtn'>
                <BsDownload />
              </button>

              {/* <button className='__bxs_srBtn'>
                <FaPrint />
              </button> */}

              {/* <button className='__bxs_srBtn'>
                <BsPencil />
              </button> */}

              <button className='__bxs_srBtn' onClick={(e) => resetFunction(e)}>
                <FiRefreshCcw />
              </button>
            </div>
          </div>
        </div>

        <div className='__hrlMain_dix'>
          <div className='voucher report-voucher  printable ng-table-reports'>
            <div className='__mainPanel'>
              <div className="panel panel-primary">
                <div className='panel-body '>
                  <div className='py-20 block-ui block-ui-anim-fade'>
                    <div className='clear-both text-center p-10'>
                      <div class="__hrlMx_head" >
                        <p> {generalLedgerData?.company?.company ? generalLedgerData?.company?.company : '-'} </p>
                        <h4> General Ledger
                          {/* {loading ? 'Loading...' : 'General Ledger List'} */}
                        </h4>
                        {/* <h5><span>Basis</span> : Accrual</h5> */}
                        <h5>From <span> {generalLedgerData?.start_date ? utils.getDateByApiResponse(generalLedgerData?.start_date) : ""} </span>  To <span> {generalLedgerData?.end_date ? utils.getDateByApiResponse(generalLedgerData?.end_date) : ""} </span></h5>
                      </div>
                    </div>

                    <div className='clear-both'>
                      <div className='report-table w-100'>
                        <table className='table report-table w-100 table-hover ng-table'>
                          <thead>
                            <tr className='ng-table-sort-header'>
                              <th className='header text-left'>
                                <div className='ng-table-header'>
                                  <span>Account</span>
                                </div>
                              </th>

                              <th className='header text-left'>
                                <div className='ng-table-header'>
                                  <span>Account Group</span>
                                </div>
                              </th>

                              <th className='header text-end pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Debit (₹)</span>
                                </div>
                              </th>

                              <th className='header text-end pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Credit (₹)</span>
                                </div>
                              </th>

                              <th className='header text-end pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Balance (₹)</span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {generalLedgerData?.list?.length > 0 ?
                              generalLedgerData?.list?.map((el, ind) => {
                                return (
                                  <tr className='ledger in ledgers cursor-pointer' key={ind}>
                                    <td className='text-left'> {el?.account_name ? el?.account_name : '-'} </td>
                                    <td className='text-left'> {el?.type_name ? el?.type_name : '-'} </td>
                                    <td className='text-end'><Link to={`/report/general_ledger/general_ledger_details/${el?.account_id}`}> {el?.total_debit?.toFixed(2)} </Link></td>
                                    <td className='text-end'><Link to={`/report/general_ledger/general_ledger_details/${el?.account_id}`}> {el?.total_credit?.toFixed(2)} </Link></td>
                                    <td className='text-end'><Link to={`/report/general_ledger/general_ledger_details/${el?.account_id}`}> {el?.balance >= 0 ? el?.balance.toFixed(2) : `(${(-(el?.balance))?.toFixed(2)})`} </Link></td>
                                  </tr>
                                )
                              })
                              :
                              <tr className='ledger in ledgers cursor-pointer'>
                                <td className='text-left'> No transactions found </td>
                                <td className='text-left'> </td>
                                <td className='text-left'> </td>
                                <td className='text-left'> </td>
                                <td className='text-left'> </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    // <div className='__hrlMain_dix'>
    //   <div className='__inr_hrlMxs'>
    //     <div>
    //       <div className='__hrlMx_head'>
    //         <p>Eminence</p>
    //         <h4>General Ledger</h4>
    //         <h5><span>From</span> 01/01/2025 <span>To</span> 31/01/2025</h5>
    //         <h5><span>Basis</span> : Accrual</h5>
    //       </div>

    //       <table className='table-no-border table-hover fixed-first-column zi-table tb-comparison-table financial-comparison' style={{ margin: '0 auto 10px' }}>
    //         <thead>
    //           <tr>
    //             <th className='text-start sortable   ascending  '>
    //               <button className='btn srt-btn'>
    //                 <div className='position-relative d-flex align-items-center '>
    //                   <div title='Account'>Account</div>
    //                 </div>
    //               </button>
    //             </th>

    //             <th className='text-end '>
    //               <button className='btn srt-btn'>
    //                 <div className='position-relative d-flex align-items-center justify-content-end '>
    //                   <div title='Debit'>Debit</div>
    //                 </div>
    //               </button>
    //             </th>

    //             <th className='text-end '>
    //               <button className='btn srt-btn'>
    //                 <div className='position-relative d-flex align-items-center justify-content-end '>
    //                   <div title='Credit'>Credit</div>
    //                 </div>
    //               </button>
    //             </th>

    //             <th className='text-end '>
    //               <button className='btn srt-btn'>
    //                 <div className='position-relative d-flex align-items-center justify-content-end '>
    //                   <div title='Balance'>Balance</div>
    //                 </div>
    //               </button>
    //             </th>
    //           </tr>
    //         </thead>

    //         <tbody>
    //           <tr>
    //             <td className='text-start'>Accounts Payable</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Accounts Receivable</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Advance Tax</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Advertising And Marketing</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Automobile Expense</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Bad Debt</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Bank Fees and Charges</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Capital Stock</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Construction Loans</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Consultant Expense</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Contract Assets</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Cost of Goods Sold</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Credit Card Charges</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Depreciation And Amortisation</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Depreciation Expense</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Dimension Adjustments</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Discount</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Distributions</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Dividends Paid</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Drawings</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Employee Advance</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Employee Reimbursements</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Exchange Gain or Loss</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Furniture and Equipment</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>General Income</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Interest Income</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Inventory Asset</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Investments</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>IT and Internet Expenses</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Janitorial Expense</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Job Costing</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Labor</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Late Fee Income</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Lodging</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Materials</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //           <tr>
    //             <td className='text-start'>Meals and Entertainment</td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //             <td className='text-end'><a href="#">0.00</a></td>
    //           </tr>
    //         </tbody>
    //       </table>

    //       <div className='position-sticky start-0'>
    //         <div className='px-4 mb-2 py-1' >
    //           <small style={{ fontSize: '12px' }}>**Amount is displayed in your base currency</small>
    //           &nbsp;
    //           <small style={{ fontSize: '9.75px' }} className='badge bg-success d-inline rounded-0'>INR</small>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  )
}

export default GeneralLedger